const SHOW_BACK = 'showBack';
const SET_TITLE = 'SET_TITLE';

export const types = {
  SHOW_BACK,
  SET_TITLE,
};

const showBack = (payload: any) => ({
  payload,
  type: SHOW_BACK,
});

const setTitle = (payload: any) => ({
  payload,
  type: SET_TITLE,
});

export const appBarActions = {
  showBack,
  setTitle,
};
